/**
 * FilesTemplates - Settings handling.
 */
$(document).ready(function() {
    var hideSharesCheckbox = $('<input>', {
        type: 'checkbox',
        id: 'hide_shares',
        name: 'hide_shares',
        class: 'checkbox'
    });

    var label = $('<label>', {
        for: 'hide_shares',
        text: 'Hide shares that are part of other shares',
        'data-v-188f517d': ''
    });

    // Target the section for new checkbox
    var targetSection = $('#files-sharing-personal-settings p').first();
    
    // Insert the checkbox and label after the existing element
    targetSection.append('<br>').append(hideSharesCheckbox).append(label);

    // Fetch and set the checkbox state based on user preference
    $.get(OC.generateUrl('/apps/ecit_40_files_templates/getPreference'), function(data) {
        if (data.hide_shares === '1') {
            hideSharesCheckbox.prop('checked', true);
        }
    });

    // Save preference on checkbox state change
    hideSharesCheckbox.on('change', function() {
        var hideShares = $(this).is(':checked') ? '1' : '0';

        $.post(OC.generateUrl('/apps/ecit_40_files_templates/savePreference'), {
            hideShares: hideShares
        });
    });
});
